/* eslint-disable react/jsx-no-useless-fragment */
import * as React from 'react';
import styled from 'styled-components';
import SwipeToDelete from 'react-swipe-to-delete-ios';
import {
	greyColour,
	greyBackground,
	superLightGreyColour,
	tabletPortraitMinWidth,
	whiteColour,
	lightGrayish,
	borderLightGrey,
	okGreen2,
	okGreen
} from '../../../cssConstants';
import { useWindowDimensions } from '../../../../commonComponents/Hooks';
import TrashRedSvg from '../../../../images/trashRed.svg';

const NotificationListSection = ({ notifications, onNotificationClick, onDelete }: Props) => {
	const { width: screenWidth } = useWindowDimensions();

	return (
		<NotificationContainer>
			{notifications?.length > 0 &&
				notifications.map((n) => (
					<SwipeToDelete
						key={n.id}
						onDelete={() => onDelete(n.id)}
						height={95}
						deleteWidth={screenWidth * 0.4}
						transitionDuration={250}
						deleteColor={greyBackground}
						deleteComponent={<SwipeDeleteIcon src={TrashRedSvg} />}
					>
						<NotificationListItem onClick={() => onNotificationClick(n.id)}>
							<NotificationInfo>
								<NotificationItemHeader>
									{n.isUnRead && <NotificationCircle />}
									<NotificationItemTitle>{n.title}</NotificationItemTitle>
									<NotificationItemTime>{n.datetime}</NotificationItemTime>
								</NotificationItemHeader>
								<NotificationDescription $isUnread={n.isUnRead}>{n.description}</NotificationDescription>
							</NotificationInfo>
						</NotificationListItem>
					</SwipeToDelete>
				))}
		</NotificationContainer>
	);
};

export default NotificationListSection;

interface Props {
	notifications: NotificationItem[];
	onNotificationClick: (userNotificationId: number) => void;
	onDelete: (userNotificationId: number) => void;
}

export interface NotificationItem {
	id: number;
	title?: string;
	description?: string;
	datetime?: string;
	isUnRead?: boolean;
}

const NotificationContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

const SwipeDeleteIcon = styled.img`
	width: 36px;
	height: 36px;
`;

const NotificationInfo = styled.div`
	flex: 1;
`;

const NotificationListItem = styled.li`
	background-color: ${whiteColour};
	border-radius: 12px;
	border: 1px solid ${borderLightGrey};
	box-shadow: 0 4px 16px 2px ${lightGrayish};
	height: 95px;
	padding: 21px 10px;
`;

const NotificationItemHeader = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 3px;
`;

export const NotificationCircle = styled.div`
	position: absolute;
	top: 10px;
	width: 9px;
	height: 9px;
	border-radius: 50%;
	background: linear-gradient(175deg, ${okGreen}, ${okGreen2});
`;

const NotificationItemTitle = styled.p`
	color: ${greyColour};
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.1px;
	padding-right: 3px;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 16px;
		line-height: 24px;
	}
`;

const NotificationItemTime = styled.p`
	font-size: 11px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.5px;
	color: #9ca3af;
	margin-left: auto;
	white-space: nowrap;
`;

const NotificationDescription = styled.p<{ $isUnread?: boolean }>`
	color: ${({ $isUnread }) => ($isUnread ? greyColour : superLightGreyColour)};
	font-size: 12px;
	font-weight: 400;
	line-height: 16px;
	letter-spacing: 0.4px;
	overflow: hidden;
	margin-bottom: 10px;
	display: -webkit-box;
	-webkit-line-clamp: 2; /* Limits to 2 lines */
	-webkit-box-orient: vertical;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 14px;
		line-height: 20px;
	}
`;
